module.exports = __webpack_public_path__ + "static/media/bch.51b9a71e.svg";